import * as React from "react";
const TextAreaIcon = (props) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9 1.75h6c2.658 0 4.435.57 5.558 1.692C21.68 4.565 22.25 6.342 22.25 9v6c0 2.658-.57 4.435-1.692 5.558-1.123 1.122-2.9 1.692-5.558 1.692H9c-2.658 0-4.435-.57-5.558-1.692C2.32 19.435 1.75 17.658 1.75 15V9c0-2.658.57-4.435 1.692-5.558C4.565 2.32 6.342 1.75 9 1.75Zm0 .5c-2.34 0-4.075.411-5.207 1.543S2.25 6.66 2.25 9v6c0 2.34.411 4.075 1.543 5.207S6.66 21.75 9 21.75h6c2.34 0 4.075-.411 5.207-1.543S21.75 17.34 21.75 15V9c0-2.34-.411-4.075-1.543-5.207S17.34 2.25 15 2.25z"
            fill="#465050"
            stroke="#465050"
        />
        <path
            d="M7 9.63a.75.75 0 0 1-.34-1.42c3.34-1.67 7.33-1.67 10.67 0 .37.19.52.64.34 1.01a.76.76 0 0 1-1.01.34 10.49 10.49 0 0 0-9.33 0c-.1.05-.22.07-.33.07"
            fill="#465050"
        />
        <path
            d="M12 17.04c-.41 0-.75-.34-.75-.75V7.93c0-.41.34-.75.75-.75s.75.34.75.75v8.37c0 .41-.34.74-.75.74"
            fill="#465050"
        />
    </svg>
);
export default TextAreaIcon;
